module.exports = function(cb) {
	require.ensure([], function(require) {
		cb(require("!!../../../../node_modules/happypack/loader.js?id=jsx!./FindingView.js"));
	}, "FindingView");
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/bundle-loader?lazy&name=FindingView!./src/pages/Learn/Finding/FindingView.js
// module id = 1729
// module chunks = 418